/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import {
  colorBorder, colorBackground, colorHover,
} from '@/utils/palette';
import { left } from '@/utils/directions';
import SidebarLink, { SidebarLinkTitle } from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { useCart } from '../../../../store/Layout/product/CartContext';

const SidebarContent = ({ onClick, collapse }) => {
  const [usersList, setUsersList] = useState([]);
  const { cartCount } = useCart();

  // getAllOtcMarketPlaceWebapp removed

  return (
    <SidebarContentWrap collapse={collapse}>
      <SidebarBlock collapse={collapse}>
        <SidebarQuickActions collapse={collapse}>
          <SidebarQuickActionItem to="/livechat" onClick={onClick} collapse={collapse}>
            <SidebarQuickActionIcon>
              <FontAwesomeIcon icon={faCommentDots} />
            </SidebarQuickActionIcon>
            {!collapse && <SidebarQuickActionText>Live Chat</SidebarQuickActionText>}
          </SidebarQuickActionItem>
          <SidebarQuickActionItem to="/showcart" onClick={onClick} collapse={collapse}>
            <SidebarQuickActionIcon>
              <FontAwesomeIcon icon={faShoppingCart} />
              {cartCount > 0 && (
                <SidebarQuickActionBadge>{cartCount}</SidebarQuickActionBadge>
              )}
            </SidebarQuickActionIcon>
            {!collapse && <SidebarQuickActionText>Cart {cartCount > 0 && `(${cartCount})`}</SidebarQuickActionText>}
          </SidebarQuickActionItem>
        </SidebarQuickActions>

        <SidebarCategory
          title={<><span> &nbsp; Wallet</span></>}
          collapse={collapse}
        >
          {!collapse && (
            <SidebarLink
              title={<><span> &nbsp; Dashboard</span></>}
              route="/dashboard"
              onClick={onClick}
            />
          )}
        </SidebarCategory>

        <SidebarLink
          title={<><span> &nbsp; Financial Dashboard</span></>}
          route="/finance"
          onClick={onClick}
        />



        <SidebarCategory
          title={<><span> &nbsp; OTC </span></>}
          collapse={collapse}
        >
          {!collapse &&
            usersList.map((user, index) => (
              <SidebarLink
                key={index}
                title={<><span> &nbsp; {user?.market_place_name}</span></>}
                route={`/otcmarketplacedetail?id=${user?._id}`}
                onClick={onClick}
              />
            ))}
        </SidebarCategory>
        <SidebarCategory
          title={<><span> &nbsp; Marketplace</span></>}
          collapse={collapse}
        >
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Home</span></>} route="/homeproducts" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Stores</span></>} route="/home" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; My Stores</span></>} route="/storedetail" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Seller Orders</span></>} route="/getmyorders" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Approvals</span></>} route="/getmyapproval" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; My Orders</span></>} route="/getmyorderasbuyer" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Custom Offers</span></>} route="/customoffers" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; FAQs</span></>} route="/faqs" onClick={onClick} />
          )}
        </SidebarCategory>

        <SidebarCategory
          title={<><span> &nbsp; Safebox</span></>}
          collapse={collapse}
        >
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; New Safebox</span></>} route="/new-safebox" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Safeboxes List</span></>} route="/safeboxes" onClick={onClick} />
          )}
        </SidebarCategory>

        <SidebarCategory
          title={<><span> &nbsp; More</span></>}
          collapse={collapse}
        >
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Currency Converter</span></>} route="/convertor" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Whitepaper</span></>} route="/whitepaper" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Token</span></>} route="/token" onClick={onClick} />
          )}
          {!collapse && (
            <SidebarLink title={<><span> &nbsp; Roadmap</span></>} route="/roadmap" onClick={onClick} />
          )}
        </SidebarCategory>

        <SidebarCategory
          title={<><span> &nbsp; Support</span></>}
          collapse={collapse}
        >
          {!collapse && (
            <SidebarLink title=" Customer Service" route="/support" onClick={onClick} />
          )}
        </SidebarCategory>
      </SidebarBlock>
    </SidebarContentWrap>
  );
};

SidebarContent.propTypes = {
  onClick: PropTypes.func,
  collapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  collapse: false,
  onClick: () => {},
};

export default SidebarContent;

// region STYLES
const SidebarContentWrap = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0;

  & > div:last-child {
    width: 4px !important;
    div {
      transition: height 0.3s;
      opacity: 0.52;
    }
  }

  @media screen and (min-width: 576px) {
    padding-top: 15px;

    ${(props) =>
      props.collapse &&
      `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
  }
`;

const SidebarQuickActions = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(31, 41, 55, 0.5);
  margin-bottom: 8px;
  
  ${props => props.collapse && `
    flex-direction: column;
    gap: 6px;
    padding: 12px 8px;
    align-items: center;
  `}
`;

const SidebarQuickActionItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(31, 41, 55, 0.5);
  color: #e5e7eb;
  text-decoration: none;
  transition: all 0.2s ease;
  flex: 1;
  position: relative;
  
  &:hover {
    background: rgba(15, 23, 42, 0.8);
    border-color: rgba(0, 247, 210, 0.3);
    transform: translateY(-1px);
    color: #e5e7eb;
    text-decoration: none;
  }
  
  ${props => props.collapse && `
    flex: none;
    width: 40px;
    height: 40px;
    padding: 0;
    justify-content: center;
  `}
`;

const SidebarQuickActionIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #00f7d2;
`;

const SidebarQuickActionBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  background: #fb7185;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  border: 2px solid rgba(15, 23, 42, 0.98);
`;

const SidebarQuickActionText = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #e5e7eb;
  white-space: nowrap;
`;

const SidebarBlock = styled.ul`
  padding: 8px 0;
  border-bottom: 1px solid rgba(31, 41, 55, 0.3);
  list-style-type: none;

  &:last-child {
    border: none;
  }

  @media screen and (min-width: 576px) {
    ${(props) =>
      props.collapse &&
      `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};

        span:last-of-type {
          opacity: 0;
          transition: 0.3s;
        }

        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
        }

        &:hover {
          background: ${colorHover(props)};
        }
      }

      & > li:hover > a,
      & > li:hover > button {
        width: 275px;

        span {
          opacity: 1;
        }
      }
    `}
  }
`;
// endregion
